import { Factory } from 'miragejs';

export default Factory.extend({
  kycStatus: 'waiting_document',
  providerName: 'fourthline',
});
